import { render, staticRenderFns } from "./cricket.vue?vue&type=template&id=ae47b392&scoped=true"
import script from "./cricket.vue?vue&type=script&lang=js"
export * from "./cricket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae47b392",
  null
  
)

export default component.exports